import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { VideoModule } from './VideoModule';

const videoSliders = [];

export class VideosSlider {
	constructor(element) {
		this.element = element;
		this.swiperElement = this.element.querySelector('[data-swiper]');
		this.prevButton = this.element.querySelector('[data-swiper-button="prev"]');
		this.nextButton = this.element.querySelector('[data-swiper-button="next"]');
		this.videoModules = [];

		this.swiper = new Swiper(this.swiperElement, {
			modules: [Navigation],
			slidesPerView: 1,
			spaceBetween: 30,
			navigation: {
				prevEl: this.prevButton,
				nextEl: this.nextButton,
			},
		});

		this.swiper.on('slideChange', () => {
			this.videoModules.forEach((videoModule) => {
				if (!videoModule.element.classList.contains('is-clicked')) {
					return;
				}

				videoModule.video.pause();
			});
		});

		this.element.querySelectorAll('[data-video-slide-video]').forEach((videoModule) => {
			this.videoModules.push(new VideoModule(videoModule));
		});
	}

	destroy() {
		this.swiper.destroy();
	}
}

document.addEventListener('bless', (e) => {
	videoSliders.forEach((slider) => slider.destroy());
	videoSliders.length = 0;

	const videoSliderElements = e.target.querySelectorAll('[data-videos-slider]');

	videoSliderElements.forEach((videoSlider) => {
		videoSliders.push(new VideosSlider(videoSlider));
	});
});
